module.exports = __webpack_public_path__ + "images/emails/bg-envelope-l-c47f7b72.png";